export default "__VITE_ASSET__hVQmyfFw__"